import React from "react"
import {useLocation, useNavigate} from "react-router-dom"
import {Tabs, Tab} from "react-bootstrap"
import RescuerSearch from "./RescuerSearch"
import RescueSearch from "./RescueSearch"
import "./SearchPage.css"

export default function AdminPage() {

    const location = useLocation()
    const navigate = useNavigate()

    const getTabKey = (pathname) => {
        if (pathname.startsWith("/rescuers")) return "rescuers"
        if (pathname.startsWith("/rescues")) return "rescues"
        return "rescuers"
    }
    
    const activeTab = getTabKey(location.pathname)
    
    return <div id="search" className="">
        <Tabs activeKey={activeTab} onSelect={key => navigate(`/${key}`)}>
            <Tab eventKey="rescuers" title="Spasioci">
                <RescuerSearch/>
            </Tab>
            <Tab eventKey="rescues" title="Povredne liste">
                <RescueSearch/>
            </Tab>
        </Tabs>
    </div>
}